import { func } from 'prop-types';
import React from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';

import createModalToggle from '../../generic/create-modal-toggle';
import UploadContacts from './UploadContacts';

function UploadContactsButton({ toggle }) {
  return (
    <>
      <ModalHeader toggle={toggle}>Upload CSV</ModalHeader>
      <ModalBody>
        <UploadContacts toggle={toggle} />
      </ModalBody>
    </>
  );
}

UploadContactsButton.propTypes = {
  toggle: func.isRequired,
};

export default createModalToggle('Upload CSV', UploadContactsButton, {
  className: 'mr-2',
});
export { UploadContactsButton }; // for unit tests
